import React, { useState } from 'react';
import ActivityRegisterModal from './ActivityRegisterModal';
import CalendarGrid from './CalendarGrid'; 
import ActivityDailyModal from './ActivityDailyModal';
// 📍 [수동 지정] 정확히 이 경로에서만 글 등록/수정/삭제를 허용합니다.
const ALLOWED_PATH = '/salesActivity'; 

// 1. 순수 JS 기반 6주차 달력 날짜 매트릭스 계산기
const getCalendarGrid = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    
    const startDayOfWeek = firstDay.getDay(); 
    const totalDays = lastDay.getDate();      
    
    const grid = [];
    for (let i = startDayOfWeek - 1; i >= 0; i--) {
        grid.push({ date: new Date(year, month, -i), isCurrentMonth: false });
    }
    for (let i = 1; i <= totalDays; i++) {
        grid.push({ date: new Date(year, month, i), isCurrentMonth: true });
    }
    const remainingDays = (7 - (grid.length % 7)) % 7;
    for (let i = 1; i <= remainingDays; i++) {
        grid.push({ date: new Date(year, month + 1, i), isCurrentMonth: false });
    }
    
    const rows = [];
    for (let i = 0; i < grid.length; i += 7) {
        rows.push(grid.slice(i, i + 7));
    }
    return rows;
};

const SalesActivityLog = ({
    holidays,
    events, 
    currentDate, 
    onDateChange, // 💡 부모 컨테이너의 setCurrentDate 함수를 수집합니다.
    onSaveActivity, 
    onDeleteActivity, 
    isCalFull 
}) => {
    // ❌ [중복 제거] 부모로부터 상태를 주입받으므로 기존 내부에 있던 아래 useState 라인은 삭제합니다!
    // const [currentDate, setCurrentDate] = useState(new Date()); 

    // 💡 달력 UI 및 모달 제어를 위한 로컬 상태들은 기존대로 원본 유지합니다.
    const [weekendsVisible, setWeekendsVisible] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [clickedDate, setClickedDate] = useState('');
    const [editData, setEditData] = useState(null);
    const [expandedDates, setExpandedDates] = useState([]); 
    const [isNonSalesModalOpen, setIsNonSalesModalOpen] = useState(false);
    const [isLocationValid, setIsLocationValid] = useState(false);
    const [isDailyModalOpen, setIsDailyModalOpen] = useState(false);

    // 📍 현재 브라우저의 도메인 뒤 경로(pathname)를 체크하는 함수
    const checkUrlLocation = () => {
        const currentPath = window.location.pathname;
        if (currentPath === ALLOWED_PATH) {
            setIsLocationValid(true);
            return true;
        } else {
            setIsLocationValid(false);
            return false;
        }
    };

    // 🚀 [연동 핵심] 내부 로컬 함수 대신 부모로부터 받은 'onDateChange'를 호출하도록 변경합니다.
    // 이렇게 해야 부모 컨테이너가 인지하여 백엔드에서 전달/전체 데이터를 새로 긁어옵니다.
    const handlePrevMonth = () => {
        onDateChange(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1));
    };
    
    const handleNextMonth = () => {
        onDateChange(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1));
    };

    const handleWeekendChange = (e) => {
        setWeekendsVisible(e.target.checked);
    };

    // 🔒 [수정] 빈 날짜 클릭 시 등록 창 오픈 원천 차단
    const handleDateClick = (dateStr) => {
        setClickedDate(dateStr);
        const isValidPath = checkUrlLocation(); // 클릭 시점에 주소창 검사
        
        // 💡 허용된 주소가 아니라면 등록 모달을 아예 열지 않고 즉시 종료합니다.
        if (!isValidPath) {
            setIsDailyModalOpen(true);
            return; 
        }

        setEditData(null);
        setClickedDate(dateStr);
        setIsModalOpen(true);
    };

    // 🔓 기존 내용 클릭 시에는 상세 내역을 보아야 하므로 무조건 모달 오픈
    const handleEventClick = (evt, e) => {
        e.stopPropagation(); 
        checkUrlLocation(); // 클릭 시점에 주소창 검사

        const startStr = evt.start || '';
        const endStr = evt.end || '';
        
        const delimiter = startStr.includes('T') ? 'T' : ' ';
        const [startDate, startTimeFull] = startStr.includes(delimiter) ? startStr.split(delimiter) : [startStr, ''];
        const startTime = startTimeFull ? startTimeFull.substring(0, 5) : '09:00';
        
        let endDate = startDate;
        let endTime = '18:00';
        if (endStr) {
            const endDelimiter = endStr.includes('T') ? 'T' : ' ';
            const [eDate, eTimeFull] = endStr.includes(endDelimiter) ? endStr.split(endDelimiter) : [endStr, ''];
            endDate = eDate;
            endTime = eTimeFull ? eTimeFull.substring(0, 5) : '18:00';
        }

        setEditData({
            activityId: evt.id,
            title: evt.title,
            startDate: startDate,
            startTime: startTime,
            endDate: endDate,
            endTime: endTime,
            companyUuid: evt.extendedProps?.companyUuid || '',            
            companyNm: evt.extendedProps?.companyNm || '', 
            meetPlace: evt.extendedProps?.meetPlace || '',
            content: evt.extendedProps?.content || '',
            usrUuid: evt.extendedProps?.usrUuid || '',
            usrNm: evt.extendedProps?.usrNm || '',
        });
        setClickedDate(startDate);
        setIsModalOpen(true);
    };
    const handleToggleExpand = (dateStr, e) => {
        e.stopPropagation(); 
        setExpandedDates(prev => 
            prev.includes(dateStr) ? prev.filter(d => d !== dateStr) : [...prev, dateStr]
        );
    };

    const calendarRows = getCalendarGrid(currentDate);
    const user = JSON.parse(localStorage.getItem('user'));

    return (
        <div style={{ padding: '0 16px', marginBottom: '16px', fontFamily: 'sans-serif' }}>
            
            {/* 상단 헤더 컨트롤 바 */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0' }}>
                <label style={{ fontSize: '14px', display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', userSelect: 'none' }}>
                    <input type="checkbox" checked={weekendsVisible} onChange={handleWeekendChange} style={{ cursor: 'pointer' }} />
                    토,일 포함
                </label>
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <button onClick={handlePrevMonth} style={btnStyle}>◀</button>
                    <h3 style={{ margin: 0, minWidth: '140px', textAlign: 'center', fontSize: '1.25rem', fontWeight: 'bold' }}>
                        {currentDate.getFullYear()}년 {currentDate.getMonth() + 1}월
                    </h3>
                    <button onClick={handleNextMonth} style={btnStyle}>▶</button>
                </div>
                <div style={{ width: '80px' }}></div>
            </div>
            
            <hr style={{ margin: '8px 0', border: 'none', borderTop: '1px solid #e0e0e0' }} />
            
            {/* 요일 가이드라인 */}
            <div style={{ display: 'grid', gridTemplateColumns: `repeat(${weekendsVisible ? 7 : 5}, 1fr)`, textAlign: 'center', fontWeight: 'bold', backgroundColor: '#f1f3f4', padding: '10px 0', borderRadius: '4px', marginBottom: '6px', fontSize: '14px' }}>
                {['일', '월', '화', '수', '목', '금', '토'].map((day, idx) => {
                    if (!weekendsVisible && (idx === 0 || idx === 6)) return null;
                    return <div key={day} style={{ color: idx === 0 ? '#d32f2f' : idx === 6 ? '#1976d2' : '#333' }}>{day}</div>;
                })}
            </div>

            {/* 캘린더 격자 바둑판 주입부 */}
            <CalendarGrid
                holidays={holidays}
                calendarRows={calendarRows}
                weekendsVisible={weekendsVisible}
                events={events}
                expandedDates={expandedDates}
                user={user}
                handleDateClick={handleDateClick}
                handleEventClick={handleEventClick}
                handleToggleExpand={handleToggleExpand}
                isCalFull={isCalFull}
            />

            {/* 검증 결과(isLocationValid) 주입 */}
            <ActivityRegisterModal 
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                selectedDate={clickedDate}
                editData={editData}
                onSave={onSaveActivity}
                onDelete={onDeleteActivity}
                isLocationValid={isLocationValid} 
            />
            <ActivityDailyModal 
                open={isDailyModalOpen}
                onClose={() => setIsDailyModalOpen(false)}
                selectedDate={clickedDate}
                events={events} // 💡 필요시 해당 날짜의 일정을 필터링해서 보여줄 수 있도록 이벤트 목록을 전달할 수 있습니다.
            />
        </div>
    );
};

const btnStyle = { padding: '4px 10px', fontSize: '12px', cursor: 'pointer', backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '4px' };

export default SalesActivityLog;
